import React from 'react';
import { computed, makeObservable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { TextField, FontSizes, FontWeights, mergeStyleSets } from '@fluentui/react';

import { Step } from 'src/components/Flowsteps/base/Step';
import { Button, classNames as baseClassNames } from 'src/components/Flowsteps/base/Flowstep';
import PullFlowstep from 'src/components/Flowsteps/PullData/PullFlowstep';

import { Type, generateFlowstepName } from 'shared/utils/flowstep';


const Data = {
  Buttons: {
    [Button.Run]: { text: 'Download CSV', tooltip: 'Downloads the chosen CSV file and saves its URL inside of the worksheet as a reusable flow step' },
    [Button.RunAndSave]: { tooltip: 'Downloads the chosen CSV file and saves its URL inside of the worksheet as a reusable flow step' },
    [Button.Save]: { tooltip: 'Updates the report URL in the current flow step without downloading the CSV file' },
  },
  textFieldStyles: { root: { marginTop: '8px' }, wrapper: { width: '100%' } },
};

const classNames = mergeStyleSets({
  tooltip: {
    display: 'inline-block',
    fontSize: FontSizes.small,
    fontWeight: FontWeights.semilight,
    marginTop: '4px',
  },
});


@inject('officeStore', 'dataStore')
export default class Csv extends PullFlowstep {
  constructor(props) {
    super(props, Type.Csv);
    makeObservable(this);

    this.options = { ...this.options, url: '' };
    this.areValid = { ...this.areValid, url: false };

    const allReactions = [...super.setupBaseReactions()];
    this.cleanReactions = () => allReactions.forEach(dispose => dispose());
  }

  get showCreateDropdownsOption() {
    return false;
  }

  @computed get _generatedName_() {
    const { worksheetName, targetCell } = this.selectionTarget || {};
    return generateFlowstepName({ type: Type.Csv, worksheetName, target: targetCell });
  }

  @computed get _buttonsData_() { return Data.Buttons; }

  @computed get _isValid_() { return super.areAllOptionsValid; }

  async _loadFlowstep_(flowstep, isExact) {
    super.loadFlowstep(flowstep, isExact);

    const { url } = flowstep.options;
    this.options = { ...this.options, url };
    this.areValid.url = !!url;
  }

  async _makeFlowstep_(makeCopy) {
    const worksheetName = 'CSV Sheet';
    const flowstep = await super.makeFlowstep(worksheetName);
    const { url } = this.options;
    Object.assign(flowstep.options, { url });

    return flowstep;
  }

  _renderBody_(renderProps) {
    const { getStepTitle } = renderProps;
    return (
      <div className={baseClassNames.content}>
        { this.renderCreateNewSheet(renderProps) }
        <Step title={getStepTitle('Link to a CSV file')}>
          <TextField
            styles={Data.textFieldStyles}
            placeholder={'Link to a file'}
            disabled={this._readOnly_}
            value={this.options.url}
            onChange={(event, value) => this.handleOptionsAndIsValidChange('url', value, !!value)}
          />
          <span className={classNames.tooltip}>
            Please make sure to specify a link that is globally accessible without authentication. An example would be a file shared with anyone with a link in Google Drive, DropBox, or a direct http(s) link to a CSV file on a web server.
          </span>
        </Step>

        {/* { this.renderErrorReaction(renderProps, { name: 'CSV file', action: 'downloaded' }) } */}
        { this.renderPullModeCombobox(renderProps) }
      </div>
    );
  }
}
